import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { KeyboardArrowDown } from '@mui/icons-material'
import { FormControl, InputLabel } from '@mui/material'
import Select from '@mui/material/Select'
import { theme } from 'styles/theme/hav-theme'

import { baseInputStyles } from '../styles'

type FormControlStyledProps = {
  displayAsSelect?: boolean
}

export const FormControlStyled = styled(FormControl)<FormControlStyledProps>`
  width: fit-content;
  .MuiSelect-select {
    border-radius: ${theme.shapes.borderRadius.sm};
  }

  ${({ displayAsSelect }) =>
    displayAsSelect
      ? css`
          width: auto;
          display: grid;
          grid-template-columns: 0.5fr minmax(80px, 1fr);
          gap: 8px;
          grid-column: unset;
          align-items: center;
          .MuiSelect-select {
            padding: 5px 15px;
          }

          .MuiInputBase-root {
            margin-top: 0;
            height: ${theme.spacing['15xm']};
          }

          svg {
            top: -1px;
            right: 9px;
            width: ${theme.spacing['15xm']};
            height: ${theme.spacing['15xm']};
          }
        `
      : css`
          .MuiSelect-select {
            padding: 0 18px 0 4px !important;
            color: ${theme.colors.primary.main};
            font-weight: ${theme.typography.weight.lg};
          }
        `}
`

type SelectStyledProps = {
  displayAsSelect?: boolean
}

export const SelectStyled = styled(Select)<SelectStyledProps>`
  font-size: ${theme.typography.sizes.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${({ displayAsSelect }) =>
    displayAsSelect ? 'transparent' : theme.colors.quartenary};
  cursor: pointer;

  ${({ displayAsSelect }) => displayAsSelect && baseInputStyles}

  ${({ displayAsSelect }) =>
    displayAsSelect &&
    css`
      .MuiSelect-select {
        display: flex;
        align-items: center;
      }
    `}

  .MuiSelect-select span {
    width: 100%;
    display: flex;
    overflow: hidden;

    ${({ disabled }) =>
      disabled &&
      css`
        -webkit-text-fill-color: ${theme.colors.neutral.medium};
      `}
  }

  .Mui-disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.neutral[100]};
  }
`

type LabelStyledProps = {
  displayAsSelect?: boolean
}

export const LabelStyled = styled(InputLabel)<LabelStyledProps>`
  margin: 0;
  z-index: 0;
  cursor: inherit;
  overflow: initial;
  position: relative;
  -webkit-transform: initial;
  transform: initial;
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};

  ${({ displayAsSelect }) =>
    displayAsSelect
      ? css`
          justify-self: flex-end;
          color: ${theme.colors.neutral.high};
          font-size: ${theme.typography.sizes['2xs']};
        `
      : css`
          color: ${theme.colors.neutral.medium};
          font-size: ${theme.typography.sizes.xs};
        `}
`

type OptionsTextProps = {
  displayAsSelect?: boolean
}

export const OptionsText = styled.span<OptionsTextProps>`
  ${({ displayAsSelect }) =>
    displayAsSelect &&
    css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing.xs};
    `}
`

export const ChevronDownIconStyled = styled(KeyboardArrowDown)`
  font-size: 18px;
  fill: ${theme.colors.primary.main};
`
